import { httpClient } from 'src/shared/api/httpClient';
import { API_PREFIX } from 'src/shared/constants';
import type {
  Business,
  BusinessUpdatePayload,
  ChangePasswordPayload,
  LoginPayload,
  ProfileUpdatePayload,
  SessionUser,
  TokenResponse,
} from './types';

const base = `${API_PREFIX}/auth`;

export const authApi = {
  login: (payload: LoginPayload) => httpClient.post<TokenResponse>(`${base}/login`, payload),

  /**
   * Revokes the refresh token server-side. Token *rotation* on a 401 lives in
   * `httpClient` instead: it is transport behaviour, not something a component
   * ever calls.
   */
  logout: (refreshToken: string) => httpClient.post<void>(`${base}/logout`, { refreshToken }),

  me: () => httpClient.get<SessionUser>(`${base}/me`),

  updateMe: (data: ProfileUpdatePayload) => httpClient.patch<SessionUser>(`${base}/me`, data),

  /** Revokes every session server-side, the caller's included. */
  changePassword: (data: ChangePasswordPayload) =>
    httpClient.post<void>(`${base}/change-password`, data),

  business: () => httpClient.get<Business>(`${API_PREFIX}/business`),

  /** Owner only (`business:manage`). Applies just the fields it receives. */
  updateBusiness: (data: BusinessUpdatePayload) =>
    httpClient.patch<Business>(`${API_PREFIX}/business`, data),
};
